export enum AgencyBrand {
    Flow = 'Flow',
    Chivaroli = 'Chivaroli',
}
